module.exports = __webpack_public_path__ + "img/gavel.f13436c7.svg";